import { render, staticRenderFns } from "./PatientTree.vue?vue&type=template&id=ac08374a&"
import script from "./PatientTree.vue?vue&type=script&lang=js&"
export * from "./PatientTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports